module.exports = __webpack_public_path__ + "img/iphone.a59f1122.svg";